import {useState, useEffect} from "react";
import {getMachinesCount} from "../../../lib/api/getMachinesCount";
import {useAuth} from "../../auth/AuthProvider";
import {Spinner, Card, Row, Col, Button} from "react-bootstrap";
import {ROUTES} from "../../../routes";
import {ExportDatasetButton} from "../../ui/ExportDatasetButton";

export const MachinesSummary = () => {
    const [machinesCount, setMachinesCount] = useState(null);
    const [connectedMachinesCount, secConnectedMachinesCount] = useState("DISABLED");

    const {token} = useAuth();

    useEffect(() => {
        getMachinesCount(token).then( (data) => {
            setMachinesCount(data["count"]);
        });

        // getConnectedMachinesCount(token).then( (data) => {
        //     secConnectedMachinesCount(data["count"]);
        // });

    }, [token]);



    return (

    <Card className="border-primary mb-4">
        <Card.Header as="h5">Machines Summary</Card.Header>
        <Card.Body>
            <Row className="mb-2">
                <Col xs={6} md={4} className="d-flex align-items-center">
                    <strong>Total Machines:</strong>&nbsp;{machinesCount} {!machinesCount && <Spinner animation="border" size="sm" />}
                </Col>
                <Col xs={6} md={4} className="d-flex align-items-center">
                    <strong>Connected Machines:</strong>&nbsp;{connectedMachinesCount} {!connectedMachinesCount && <Spinner animation="border" size="sm" />}
                </Col>
                <Col xs={12} md={4} className="d-flex justify-content-md-end align-items-center mt-2 mt-md-0">
                    <Button variant="outline-primary" href={ROUTES.MACHINES_REPORT} >
                        View Report
                    </Button> &nbsp;

                    <ExportDatasetButton />

                </Col>

            </Row>
        </Card.Body>
    </Card>

    )
};
